const listeners = new Set();
let latest = null;
/** Main live player can publish a still for the selected channel tile (no second upstream open). */
export function publishLivePoster(payload) {
    if ((latest === null || latest === void 0 ? void 0 : latest.posterUrl) && latest.posterUrl.startsWith('blob:') && latest.posterUrl !== (payload === null || payload === void 0 ? void 0 : payload.posterUrl)) {
        URL.revokeObjectURL(latest.posterUrl);
    }
    latest = payload;
    listeners.forEach((listener) => listener(payload));
}
export function getLivePoster() {
    return latest;
}
export function subscribeLivePoster(listener) {
    listeners.add(listener);
    if (latest) {
        listener(latest);
    }
    return () => {
        listeners.delete(listener);
    };
}
export function grabVideoPosterDataUrl(element) {
    if (!element || element.videoWidth <= 0 || element.videoHeight <= 0) {
        return null;
    }
    if (element.readyState < HTMLMediaElement.HAVE_CURRENT_DATA) {
        return null;
    }
    try {
        const canvas = document.createElement('canvas');
        canvas.width = element.videoWidth;
        canvas.height = element.videoHeight;
        const context = canvas.getContext('2d');
        if (!context) {
            return null;
        }
        context.drawImage(element, 0, 0);
        return canvas.toDataURL('image/jpeg', 0.72);
    }
    catch (_a) {
        return null;
    }
}
